import { Action } from '../constants';
const initialState = {
  transactionList: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Action.TRANSACTIONS_LIST_REQUEST:
      return {
        ...state,
        loading: true
      };
    case Action.TRANSACTIONS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        transactionList: action.payload
      };
    case Action.TRANSACTIONS_LIST_FAILURE:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
};
